module.exports = __webpack_public_path__ + "img/7580.469ab913.svg";